import { BoxHeaderPrimaryCss, TextDela } from './index.css'
interface IProps {
	children?: React.ReactNode
	title: string
}
export default function BoxHeaderPrimary({ title, children }: IProps) {
	return (
		<BoxHeaderPrimaryCss>
			<div className='header'>
				<TextDela>{title}</TextDela>
			</div>
			<div className='main'>{children}</div>
		</BoxHeaderPrimaryCss>
	)
}
